var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[(_vm.user.avatar)?_c('img',{staticClass:"h-6 w-6 m-auto",attrs:{"src":`${_vm.storageUrl}/avatars/${_vm.user.avatar}.png`}}):_c('i',{staticClass:"fas fa-user"})])
}
var staticRenderFns = []

export { render, staticRenderFns }